<!--refresher-->
<ion-refresher class="ion-hide-sm-up" slot="fixed" [pullFactor]="0.5" [pullMin]="100" (ionRefresh)="refresh($event)">
    <ion-refresher-content></ion-refresher-content>
</ion-refresher>
<!--refresher end-->

<ion-row class="semi-header-block ion-justify-content-between">
    <ion-col>
        <div class="name-card-wrapper">

            <div class="avatar-wrapper">
                <ion-avatar class="avatar" *ngIf="!this.student?.avatar">
                    <img *ngIf="this.student?.gender === 1" alt="child profile" src="assets/images/child/boy.png"
                         width="52px"/>

                    <img *ngIf="this.student?.gender === 2" alt="child profile" src="assets/images/child/girl.png"
                         width="52px"/>
                </ion-avatar>

                <ion-avatar *ngIf="this.student?.avatar" class="avatar"
                            [ngStyle]="{'background-image': 'url(' + this.student?.avatar + ')'}">
                </ion-avatar>

                <ion-badge slot="start" class="badge" (click)="openEditPhotoModal()">
                    <img alt="child profile" src="assets/images/icons/photo.svg"/>
                </ion-badge>
            </div>


            <div class="name-wrapper">
                <div class="name">Hello, {{ this.student?.firstName }}</div>
                <div class="slogan">{{ this.student?.motivationalPhrase }}</div>
            </div>
        </div>


    </ion-col>


    <ion-col size="3" size-sm="12" size-xs="12" size-md="4" size-lg="3" size-xl="3"
             class="ion-no-padding ion-no-margin">
        <div class="countrics-wrapper" [routerLink]="'/countrics'">
            <div class="info">
                <div class="title">{{ 'semiHeaderComp.countrics'|transloco }}</div>
                <div class="amount">{{ this.student?.countricsBalance }}</div>
            </div>
            <div class="image">
                <img src="assets/images/student/cantrics.png" alt="money">
            </div>
        </div>
    </ion-col>
</ion-row>


<ion-row *transloco="let t; read: 'profileBarComp'">
    <ion-col size="12" class="ion-no-margin ion-no-padding">

        <app-tabs [styleGroup]="true" [showSchedule]="true" [studentStyle]="true" *ngIf="studentHasGroups"
                  (changeTab)="onTabChange($event)">

            <app-tab [tabTitle]="t('currentCourses')" [svg]="true" [active]="activeCurrentGroupsTabs"
                     [time]="'isCurrent'">

                <ion-row class="study-content ion-no-padding  ion-no-margin"
                         *ngIf="(student?.onlineTestRequiredSecondTime ||student?.onlineTestRequired)  && studentHasGroups">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <app-lesson-test [isEnglishLevel]="true" [noMarginBottom]="true" [try]="student?.onlineTestRequiredTriesLeft"></app-lesson-test>
                    </ion-col>

                </ion-row>

                <ion-row class="study-content ion-no-padding ion-no-margin" *ngIf="student?.studentComment">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <app-main-notification *ngIf="student?.studentComment"
                                               [studentComment]="student?.studentComment"></app-main-notification>
                    </ion-col>

                </ion-row>


                <ion-row class=" study-content ion-no-padding  ion-no-margin"
                         *ngIf="student?.periodicExams?.length !=0">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <div *ngFor="let exam of student?.periodicExams">
                            <app-lesson-test [exam]="exam"></app-lesson-test>
                        </div>
                    </ion-col>

                </ion-row>


                <ion-row class="study-content ion-no-padding" *ngIf="this.activeTabGroups && !processRequest">

                    <div *ngFor="let group of this.activeTabGroups">
                        <app-student-notification [type]="'error'"
                                                  *ngIf="group.isReserve"></app-student-notification>


                        <ion-col size="12" class="ion-no-padding ion-no-margin">

                            <app-student-group
                                [group]="group"
                                [class]="group.color === '80b0b2' ? 'light-blue-bg' : group.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                                [lessonStart]="true"
                                [isCurrent]="true"
                                [hideEducationMaterials]="group.isReserve">
                            </app-student-group>
                        </ion-col>


                        <ion-col size="12" class="ion-no-padding ion-no-margin with-margin-bottom"
                                 *ngIf="group.transferredLessons.length>0  ">


                            <app-lesson-practice *ngFor="let lesson of group.transferredLessons"
                                                 [lessonStart]=true
                                                 [class]="'yellow-bg'"
                                                 [lesson]=lesson
                                                 [isTransferredLesson]="true"
                            ></app-lesson-practice>


                        </ion-col>

                    </div>



                    <ion-col size="12" class="ion-no-padding ion-no-margin white-col with-margin-bottom"
                             *ngIf="this.activeTabGroups.length == 0">

                        <app-no-course-notice [currentGroup]="true" [class]="'border-grey'"></app-no-course-notice>

                    </ion-col>


                    <ion-col size="12" class="ion-no-padding ion-no-margin with-margin-bottom"
                             *ngIf="this.studentHasRework && this.activeTabGroups.length> 0 ">


                        <app-lesson-practice *ngFor="let lesson of this.student?.reworkLessons"
                                             [lessonStart]=true
                                             [class]="'yellow-bg'"
                                             [lesson]=lesson
                        ></app-lesson-practice>


                    </ion-col>

                    <ion-col size="12" class="ion-no-padding ion-no-margin" *ngIf="!this.processRequest">


                        <app-student-statistic [newExam]="this.student?.newExams"
                                               [typeGroup]="'current'"></app-student-statistic>


                    </ion-col>


                    <ion-col size="12" class="ion-no-padding ion-no-margin" *ngIf="this.activeTabGroups.length> 0 ">
                        <button type="button" class="content-btn grey-btn" (click)="openModal('practicing')">
                            <div class="content-inner">
                                <img ngSrc="assets/images/student/student.png" alt="student" height="56" width="58"/>

                                {{ t('startPracticing') }}

                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                                          fill="#3F403F"/>
                                </svg>

                            </div>


                        </button>

                        <button type="button" class="content-btn grey-btn" (click)="openTransferModal()">
                            <div class="content-inner">
                                <img ngSrc="assets/images/student/transfer_lesson.png" alt="student" height="56"
                                     width="58"/>

                                {{ t('transferClass') }}

                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                                          fill="#3F403F"/>
                                </svg>

                            </div>


                        </button>


                        <button type="button" class="content-btn grey-btn" (click)="openRequestModal('continueStudy')">
                            <div class="content-inner">
                                <img ngSrc="assets/images/student/textbook.png" alt="student" height="41" width="56"/>

                                {{ t('nextCourse') }}

                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M8.51192 19.5694C8.19743 19.2999 8.161 18.8264 8.43057 18.5119L14.0122 12L8.43057 5.4881C8.161 5.1736 8.19743 4.70013 8.51192 4.43056C8.82641 4.16099 9.29989 4.19741 9.56946 4.51191L15.5695 11.5119C15.8102 11.7928 15.8102 12.2072 15.5695 12.4881L9.56946 19.4881C9.29989 19.8026 8.82641 19.839 8.51192 19.5694Z"
                                          fill="#3F403F"/>
                                </svg>

                            </div>


                        </button>


                    </ion-col>
                </ion-row>


            </app-tab>

            <app-tab [tabTitle]="t('futureCourses')" [svg]="true" [active]="activeFuturesGroupsTabs"
                     [time]="'isFuture'">


                <ion-row class="study-content ion-no-padding  ion-no-margin"
                         *ngIf="(student?.onlineTestRequiredSecondTime ||student?.onlineTestRequired)  && studentHasGroups">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <app-lesson-test [isEnglishLevel]="true" [try]="student?.onlineTestRequiredTriesLeft"></app-lesson-test>
                    </ion-col>

                </ion-row>

                <ion-row class="study-content ion-no-padding ion-no-margin" *ngIf="student?.studentComment">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <app-main-notification *ngIf="student?.studentComment"
                                               [studentComment]="student?.studentComment"></app-main-notification>
                    </ion-col>

                </ion-row>


                <ion-row class=" study-content ion-no-padding  ion-no-margin"
                         *ngIf="student?.periodicExams?.length !=0">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <div *ngFor="let exam of student?.periodicExams">
                            <app-lesson-test [exam]="exam"></app-lesson-test>
                        </div>
                    </ion-col>

                </ion-row>

                <ion-row class="study-content ion-no-padding" *ngIf="activeTabGroups && !processRequest">

                    <div *ngFor="let group of this.activeTabGroups">

                        <ion-col size="12" class="ion-no-padding ion-no-margin">
                            <app-student-notification [type]="'error'"
                                                      *ngIf="group.isReserve"></app-student-notification>
                        </ion-col>


                        <ion-col size="12" class="ion-no-padding ion-no-margin">

                            <app-student-group [group]="group"
                                               [class]="group.color === '80b0b2' ? 'light-blue-bg' : group.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                                               [lessonStart]="true"
                                               [isFuture]="true"
                                               [hideEducationMaterials]="group.isReserve">

                            </app-student-group>
                        </ion-col>

                        <ion-col size="12" class="ion-no-padding ion-no-margin with-margin-bottom"
                                 *ngIf="group.transferredLessons.length>0  ">


                            <app-lesson-practice *ngFor="let lesson of group.transferredLessons"
                                                 [lessonStart]=true
                                                 [class]="'yellow-bg'"
                                                 [lesson]=lesson
                                                 [isTransferredLesson]="true"
                            ></app-lesson-practice>


                        </ion-col>

                    </div>

                </ion-row>


                <ion-row *ngIf="this.activeTabGroups?.length === 0 && !processRequest"
                         class="study-content ion-no-padding">
                    <ion-col size="12" class="ion-no-padding ion-no-margin white-col with-margin-bottom">
                        <app-no-course-notice [futureGroup]="true" [class]="'border-grey'"></app-no-course-notice>

                    </ion-col>
                </ion-row>


                <ion-row class="study-content ion-no-padding" *ngIf="!this.processRequest">
                    <ion-col size="12" class="ion-no-padding ion-no-margin">


                        <app-student-statistic [newExam]="this.student?.newExams"
                                               [typeGroup]="'future'"></app-student-statistic>


                    </ion-col>

                </ion-row>

            </app-tab>


            <app-tab [tabTitle]="t('passedCourses')" [svg]="true" [active]="activePassedGroupsTabs" [time]="'isPast'">

                <ion-row class="study-content ion-no-padding  ion-no-margin"
                         *ngIf="(student?.onlineTestRequiredSecondTime ||student?.onlineTestRequired)  && studentHasGroups">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <app-lesson-test [isEnglishLevel]="true" [try]="student?.onlineTestRequiredTriesLeft"></app-lesson-test>
                    </ion-col>

                </ion-row>

                <ion-row class="study-content ion-no-padding ion-no-margin" *ngIf="student?.studentComment">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <app-main-notification *ngIf="student?.studentComment"
                                               [studentComment]="student?.studentComment"></app-main-notification>
                    </ion-col>

                </ion-row>


                <ion-row class=" study-content ion-no-padding  ion-no-margin"
                         *ngIf="student?.periodicExams?.length !=0">
                    <ion-col class="ion-no-padding ion-no-margin">
                        <div *ngFor="let exam of student?.periodicExams">
                            <app-lesson-test [exam]="exam"></app-lesson-test>
                        </div>
                    </ion-col>

                </ion-row>

                <ion-row *ngIf="this.activeTabGroups && !processRequest" class="study-content ion-no-padding">


                    <div *ngFor="let group of this.activeTabGroups; let i = index">

                        <ion-col size="12" class="ion-no-padding ion-no-margin" *ngIf="i === 0">

                            <app-student-notification [type]="'past'"></app-student-notification>
                        </ion-col>

                        <ion-col size="12" class="ion-no-padding ion-no-margin">

                            <app-student-group
                                [group]="group"
                                [class]="group.color === '80b0b2' ? 'light-blue-bg' : group.color === 'EBC700' ? 'yellow-bg': 'green-bg'"
                                [lessonStart]="true"
                                [isPast]="true"
                                [hideEducationMaterials]="group.isReserve">
                            </app-student-group>
                        </ion-col>

                    </div>

                </ion-row>


                <ion-row *ngIf="this.activeTabGroups?.length === 0 && !processRequest"
                         class="study-content ion-no-padding">
                    <ion-col size="12" class="ion-no-padding ion-no-margin white-col with-margin-bottom">
                        <app-no-course-notice [pastGroup]="true" [class]="'border-grey'"></app-no-course-notice>

                    </ion-col>
                </ion-row>

                <ion-row class="study-content ion-no-padding" *ngIf="!this.processRequest">

                    <ion-col size="12" class="ion-no-padding ion-no-margin">

                        <app-student-statistic [newExam]="this.student?.newExams"
                                               [typeGroup]="'past'"></app-student-statistic>

                    </ion-col>


                </ion-row>


            </app-tab>

        </app-tabs>


        <ion-row class="study-content ion-no-padding" *ngIf="studentHasGroups == false">

            <ion-col size="12" class="ion-no-padding ion-no-margin white-col with-margin-top"
                     *ngIf="this.student?.levelTitle === '' || this.student?.onlineTestRequired">

                <app-old-student-info [doTest]="this.student?.onlineTestRequired"></app-old-student-info>

            </ion-col>


            <ion-col size="12" class="ion-no-padding ion-no-margin with-margin-top"
                     *ngIf="hasEnterTest && !this.student?.onlineTestRequired && this.student?.toShowEnglishLevelResult && !this.student?.isItBeforeSchoolChild">
                <app-new-student-info [title]="this.student?.levelTitle"
                                      [beforeSchool]="this.student?.isItBeforeSchoolChild"
                                      [withButtonRequest]="true"
                                      [secondTryTestLink]="this.student?.onlineTestRequiredSecondTime"></app-new-student-info>

            </ion-col>

            <ion-col size="12" class="ion-no-padding ion-no-margin white-col with-margin-top"
                     *ngIf="hasEnterTest && !this.student?.onlineTestRequired && !this.student?.toShowEnglishLevelResult || this.student?.isItBeforeSchoolChild">
                <!--                     *ngIf="(hasEnterTest || this.student?.levelTitle)  && !this.student?.onlineTestRequired && !this.student?.isItBeforeSchoolChild && this.student?.isNewStudentWithoutGroups != true">-->


                <app-old-student-info></app-old-student-info>

            </ion-col>


            <ion-col size="12" class="ion-no-padding ion-no-margin white-col greeting-content">
                <!--                <ion-col size="12" class="ion-no-padding ion-no-margin white-col greeting-content"-->
                <!--                     *ngIf="hasEnterTest && !this.student?.onlineTestRequired || this.student?.isItBeforeSchoolChild || !hasEnterTest && this.student?.onlineTestRequired">-->

                <div size="12" class="video-greeting">

                    <div class="title">

                        {{t('videoGreeting')}}

                    </div>
                    <div class="video-greeting-wrapper">

                        <iframe class="embed-responsive-item" width="100%" height="100%" [src]="this.saveVideoLink"
                                allow="autoplay; encrypted-media"
                                allowfullscreen></iframe>

                    </div>


                </div>

            </ion-col>
        </ion-row>


        <ion-row class="study-content ion-no-padding">
            <ion-col size="12" class="ion-no-padding ion-no-margin" *ngIf="this.student?.banners">
                <app-banners [banners]="this.student?.banners"></app-banners>
            </ion-col>

            <ion-col size="12" class="ion-no-padding ion-no-margin" *ngIf="this.student">
                <app-feedback *ngIf="this.student?.totalGroupAmount"></app-feedback>
            </ion-col>

        </ion-row>


    </ion-col>


</ion-row>


<!--<ion-button (click)="goBackToParentCabinet()"> Перейти у кабінет представника</ion-button>-->
